import { render } from "./AppointmentCarousel.vue?vue&type=template&id=14721bcd&scoped=true"
import script from "./AppointmentCarousel.vue?vue&type=script&lang=js"
export * from "./AppointmentCarousel.vue?vue&type=script&lang=js"

import "./AppointmentCarousel.vue?vue&type=style&index=0&id=14721bcd&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14721bcd"]])

export default __exports__